import { _ as __rest } from '../../CopilotMessagePartWrapper-B-bkNXc6.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { IconButton } from '@zapier/design-system';
import { CopilotMessagePart } from '../CopilotMessagePart/CopilotMessagePart.es.js';

const message = "_message_ut1wt_1";
const actions = "_actions_ut1wt_6";
const action = "_action_ut1wt_6";
const userActions = "_userActions_ut1wt_15";
const assistantActions = "_assistantActions_ut1wt_19";
const styles = {
	message: message,
	actions: actions,
	action: action,
	userActions: userActions,
	assistantActions: assistantActions
};

const getPartKey = (message, part, index) => {
  if (part.type === "text" && part.text) {
    return `${message.id}-${part.type}-${index}-${part.text.substring(0, 10)}`;
  }
  return `${message.id}-${part.type}-${index}`;
};
const CopilotMessage = (_a) => {
  var { message, className, style, renderPart, actions = [], isDebug, renderPartContent, getToolCallDisplay } = _a, props = __rest(_a, ["message", "className", "style", "renderPart", "actions", "isDebug", "renderPartContent", "getToolCallDisplay"]);
  const { content, parts, role } = message;
  const isUser = role === "user";
  const cleanedParts = parts.length > 0 ? parts : [
    {
      type: "text",
      text: content
    }
  ];
  return React.createElement(
    "div",
    Object.assign({ className: clsx([styles.message, className]), style, "data-zds": true }, props),
    cleanedParts.map((part, index) => {
      const key = getPartKey(message, part, index);
      const rendered = renderPart ? renderPart(message, part, index) : void 0;
      return React.createElement(React.Fragment, { key }, rendered !== null && rendered !== void 0 ? rendered : React.createElement(CopilotMessagePart, { message, part, isDebug, renderPartContent, getToolCallDisplay }));
    }),
    actions.length > 0 && // TODO: Consider breaking into another component w/ React.memo
    React.createElement("div", { className: clsx(styles.actions, isUser ? styles.userActions : styles.assistantActions) }, actions.map((control) => React.createElement(IconButton, {
      key: control.id,
      className: styles.action,
      //TODO: Resolve this in design-system. ZinniaIcons and DS Icon types
      // don't completely match.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      name: control.icon,
      variant: "ghost",
      size: "small",
      "aria-label": control["aria-label"],
      onPress: () => control.onClick(control.id, message),
      "data-zds": true
    })))
  );
};
CopilotMessage.displayName = "CopilotMessage";

export { CopilotMessage, CopilotMessage as default };
//# sourceMappingURL=CopilotMessage.es.js.map
